export const cn = {
    creditsPricing: {
        title: '选择最适合您的方案',
        subtitle: '解锁专业功能，提升您的工作效率',
        headerTexts: {
            pricing_proactive_view: { title: '选择适合你的方案', subtitle: '升级套餐或增加 Credits，解锁更多能力。' },
            feature_upgrade_required: { title: '升级后即可使用此功能', subtitle: '此功能不包含在当前方案中，请升级后继续。' },
            credits_limit_upgrade: { title: 'Credits 不足', subtitle: '增加 Credits 或升级套餐后，即可继续使用。' },
        },
        free: '免费',
        currentPlan: '当前方案',
        recommend: '推荐',
        monthly: '月付',
        yearly: '年付',
        month: '月',
        perMonth: '/月',
        save: '省 $ {amount}',
        upgrade: '升级',
        downgrade: '降级',
        contactSales: '联系销售',
        bookDemo: '预约演示',
        custom: '定制化',
        learnMore: '了解更多',
        creditsPerMonth: '{credits} 积分/月',
        creditsPerMonthSuffix: '积分/月',
        scheduledDowngrade: '预约降级',
        scheduledDowngradeNotice: '预约 {date} 降级到 {tier}',
        fiveXCreditsNotice: {
            title: '早鸟优惠已为您激活。',
            description: '每个套餐包含标准积分的 {multiplier} 倍，续费时将保持相同费率。如有变更，我们将在下一个计费周期前 7 天通知您。',
        },
        freeCreditsRefresh: '免费积分每月刷新',
        creditsIncluded: '专业版方案包含的积分',
        everythingInBasic: '包含基础版全部能力，并增加：',
        everythingInPro: '包含个人专业版全部能力，并增加：',
        everythingInProPlus: '包含个人专业版全部能力，并增加：',
        securityControl: '安全与管理',
        audienceTabs: {
            individual: '个人',
            teams: '团队与企业',
        },
        enterpriseCategories: {
            teamUsage: '团队使用与管理',
            collaboration: '协作',
            governanceSecurity: '治理与安全',
            serviceSuccess: '服务与成功',
        },
        apiCategories: {
            customWorkflowApi: '自定义工作流 API',
            plugAndPlayUiComponents: '即插即用 UI 组件',
            enterpriseAiMcpServer: '面向企业 AI 的 MCP 服务器',
            agentSkillsSdk: '智能体技能与 SDK',
            interactiveDeveloperPlayground: '交互式开发者体验场',
        },
        basic: '基础版',
        pro: '个人专业版',
        enterprise: '企业版',
        api: '开放平台',
        basicDesc: '用核心 AI 工作流快速起步',
        proDesc: '面向运行真实工作流的专业用户',
        enterpriseDesc: '面向团队，安全扩展全流程创新能力',
        apiDesc: '把研发智能嵌入你自己的系统',
        features: {
            basic1: '可使用部分核心智能体',
            basic2: '内置技能和连接器，提供开箱即用的研发工作流与精选数据工具',
            basic3: 'AI 驱动的情报简报，持续追踪竞争情报',
            pro1: '更深入的智能体工作流，覆盖研究、撰写、验证与监控',
            pro2: '可导出带证据支撑的专业成果（专利与文献）',
            pro3: '追踪更多技术主题和竞争信号',
            // Enterprise - Team usage & administration
            enterpriseTeam1: '按团队需求定制访问权限',
            enterpriseTeam2: '团队共享积分池，支持自定义分配',
            enterpriseTeam3: '管理员控制台，统一管理账单、用量和用户',
            // Enterprise - Collaboration
            enterpriseCollab1: '共享工作区和团队项目',
            enterpriseCollab2: '团队级情报分发',
            // Enterprise - Governance & Security
            enterpriseSecurity1: 'SSO 与企业级安全控制',
            enterpriseSecurity2: '基于角色的用户和工作区权限',
            enterpriseSecurity3: '文件上传控制',
            enterpriseSecurity4: '私密无痕模式',
            // Enterprise - Service & Success
            enterpriseService1: '专属客户支持',
            enterpriseService2: '99.9% SLA 与主动监控',
            enterprise1: '个人成员配额管理',
            enterprise2: '无限团队共享知识库',
            security1: '内部情报共享',
            security2: '隐私无痕模式',
            security3: '统一团队权限管理',
            security4: '专属客户支持',
            api1: '覆盖专利、生命科学、研发和市场情报的 300+ 数据 API 与 60+ AI 智能体 API',
            api2: '将图表、洞察和 AI 工作流嵌入你的产品，无需重建',
            api3: '通过任何兼容 MCP 的客户端连接可信 PatSnap 工具，包括 Claude Desktop 和 Cursor',
            api4: '使用 LangChain、OpenClaw、CrewAI 等框架构建和编排工作流',
            api5: '在一个平台内探索场景演示、测试 API、构建组件并生成代码',
        },
        // 升级确认弹窗
        upgradeConfirm: {
            title: '升级',
            titleWithTier: '升级到 {tier}',
            subtitle: '升级立即生效。',
            currentPlan: '当前方案',
            targetPlan: '目标方案',
            dueToday: '今日应付',
            creditsGrantedToday: '今日获得积分',
            creditsValidUntil: '积分有效期至',
            nextRenewal: '下次续费',
            creditsRetainedNotice: '您现有的积分将被保留，可与新积分一起使用。',
            loadFailed: '加载升级详情失败。',
            retry: '重试',
            cancel: '取消',
            processing: '处理中...',
            upgradeNow: '立即升级',
            credits: '+{amount} 积分',
            upgradeSuccess: '感谢订阅！ 你的早鸟奖励已到账：5 倍积分已发放至你的账户，快去查看吧。',
        },
        // 降级确认弹窗
        downgradeConfirm: {
            title: '预约降级',
            titleWithTier: '预约降级到 {tier}',
            subtitle: '您的 {tier} 套餐将保持有效至 {date}。',
            currentPlan: '当前方案',
            scheduledPlan: '当前降级方案',
            newDowngradePlan: '新降级方案',
            effectiveDate: '生效日期',
            currentCredits: '当前积分',
            creditsKept: '保留至原到期日',
            creditsExpire: '将在周期结束时过期',
            creditsNextCycle: '下周期积分',
            nextRenewal: '下次续费',
            renewalAmount: '{date} 续费 {currency} {amount}',
            cancelNotice: '您可以在 {date} 之前取消此预约降级。',
            loadFailed: '加载降级详情失败。',
            retry: '重试',
            keepCurrentPlan: '保持当前方案',
            keepTier: '保持 {tier}',
            processing: '处理中...',
            scheduleDowngrade: '预约降级',
            credits: '{amount} 积分',
            successMessage: '降级已预约成功！您的 {tier} 套餐将保持有效至 {date}。',
        },
        oldProTip: {
            title: '暂无法更新订阅',
            description: '你当前仍在旧版 Pro 订阅周期内。旧版计次套餐和 Credits 积分套餐不能同时生效。如需切换到 Credits 积分套餐，请先取消续订；当前订阅结束后，你可以重新订阅新套餐。',
            confirm: '查看订阅',
            cancel: '我知道了',
        },
        coreAgents: {
            note: '精选智能体包括：',
            line1: 'IP 检索：查新检索 / 防侵权检索 / 外观防侵权检索',
            line2: 'IP 撰写：专利申请 / 交底书 / 审查意见答复',
            line3: 'SEP：标准比对',
            line4: '工程研发：TRIZ 寻找创新方案 / 技术预研报告',
            line5: '生命科学：Lead 化合物分析 / SAR 数据提取 / 文档精读',
            line6: '材料研发：材料技术方案探索 / 配方助手',
        },
    },
};

export const en = {
    creditsPricing: {
        title: 'Choose the Right Plan for You',
        subtitle: 'Unlock professional features and boost your productivity',
        headerTexts: {
            pricing_proactive_view: { title: 'Simple Plans. Scalable Usage.', subtitle: 'Scale from individual workflows to enterprise-grade automation' },
            feature_upgrade_required: { title: 'Upgrade to use this feature', subtitle: 'This feature is not included in your current plan.' },
            credits_limit_upgrade: { title: 'Not Enough Credits', subtitle: 'Add more credits or upgrade your plan to continue.' },
        },
        free: 'Free',
        currentPlan: 'Current Plan',
        recommend: 'Recommend',
        monthly: 'Monthly',
        yearly: 'Yearly',
        month: 'month',
        perMonth: '/month',
        save: 'Save $',
        upgrade: 'Upgrade',
        downgrade: 'Downgrade',
        contactSales: 'Contact Sales',
        bookDemo: 'Book a Demo',
        custom: 'Custom',
        learnMore: 'Learn More',
        creditsPerMonth: '{credits} credits/month',
        creditsPerMonthSuffix: 'credits/month',
        scheduledDowngrade: 'Scheduled Downgrade',
        scheduledDowngradeNotice: 'Scheduled to downgrade to {tier} on {date}',
        fiveXCreditsNotice: {
            title: 'Early access pricing is active for you.',
            description: 'Every plan includes {multiplier} the standard credits, and your renewal will honor the same rate. If this ever changes, we\'ll notify you 7 days before your next billing cycle.',
        },
        freeCreditsRefresh: 'Free credits refresh monthly',
        creditsIncluded: 'Credits included in your Pro plan',
        everythingInBasic: 'Everything in Basic, plus',
        everythingInPro: 'Everything in Personal Pro, plus',
        everythingInProPlus: 'Everything in Personal Pro, plus',
        securityControl: 'Security & Control',
        audienceTabs: {
            individual: 'Individual',
            teams: 'Teams & Enterprise',
        },
        enterpriseCategories: {
            teamUsage: 'Team usage & administration',
            collaboration: 'Collaboration',
            governanceSecurity: 'Governance & Security',
            serviceSuccess: 'Service & Success',
        },
        apiCategories: {
            customWorkflowApi: 'APIs for custom workflows',
            plugAndPlayUiComponents: 'Drop-in UI Widgets',
            enterpriseAiMcpServer: 'MCP Servers for enterprise AI',
            agentSkillsSdk: 'Agent Skills & SDKs',
            interactiveDeveloperPlayground: 'Interactive Developer Playground',
        },
        basic: 'Basic',
        pro: 'Pro',
        enterprise: 'Enterprise',
        api: 'Open Platform',
        basicDesc: 'Get started with core AI workflows',
        proDesc: 'For professionals running real workflows',
        enterpriseDesc: 'For teams scaling full-cycle innovation power securely',
        apiDesc: 'Embed R&D intelligence into your own stack',
        features: {
            basic1: 'Access to selected core agents',
            basic2: 'Built-in skills and connectors with ready-made R&D workflows and curated data tools',
            basic3: 'AI-enabled Pulse briefs tracking competitive intelligence',
            pro1: 'Deeper agent workflows for research, drafting, validation, and monitoring',
            pro2: 'Professional exports with supporting evidence (patents&literature)',
            pro3: 'More racked technical topics and competitive signals',
            // Enterprise - Team usage & administration
            enterpriseTeam1: 'Tailored access for your team\'s needs',
            enterpriseTeam2: 'Team-pooled credits with custom allocation',
            enterpriseTeam3: 'Admin console for billing, usage, and user management',
            // Enterprise - Collaboration
            enterpriseCollab1: 'Shared workspaces and team projects',
            enterpriseCollab2: 'Team-wide intelligence distribution',
            // Enterprise - Governance & Security
            enterpriseSecurity1: 'SSO and enterprise security controls',
            enterpriseSecurity2: 'Role-based permissions for users and workspaces',
            enterpriseSecurity3: 'File upload controls',
            enterpriseSecurity4: 'Private incognito mode',
            // Enterprise - Service & Success
            enterpriseService1: 'Dedicated customer support',
            enterpriseService2: '99.9% SLA and proactive monitoring',
            enterprise1: 'Individual member quota management',
            enterprise2: 'Unlimited Shared Vaults for Teams',
            security1: 'Internal intelligence sharing',
            security2: 'Private incognito mode',
            security3: 'Unified team permission management',
            security4: 'Dedicated customer support',
            api1: '300+ data APIs and 60+ AI agent APIs across patents, life sciences, R&D, and market intelligence',
            api2: 'Embed charts, insights, and AI workflows into your product — no rebuild required',
            api3: 'Connect trusted PatSnap tools through any MCP-compatible client, including Claude Desktop and Cursor',
            api4: 'Build and orchestrate workflows with LangChain, OpenClaw, CrewAI, and other frameworks',
            api5: 'Explore scenario demos, test APIs, build widgets, and generate code in one place',
        },
        // Upgrade confirm dialog
        upgradeConfirm: {
            title: 'Upgrade',
            titleWithTier: 'Upgrade to {tier}',
            subtitle: 'Your upgrade starts immediately.',
            currentPlan: 'Current plan',
            targetPlan: 'Target plan',
            dueToday: 'Due today',
            creditsGrantedToday: 'Credits granted today',
            creditsValidUntil: 'Credits valid until',
            nextRenewal: 'Next renewal',
            creditsRetainedNotice: 'Your existing credits will be retained and can be used alongside your new credits.',
            loadFailed: 'Failed to load upgrade details.',
            retry: 'Retry',
            cancel: 'Cancel',
            processing: 'Processing...',
            upgradeNow: 'Upgrade now',
            credits: '+{amount} credits',
            upgradeSuccess: 'Thanks for subscribing！ Your early bird bonus has arrived: 5× credits have been added to your account. Go check them out.',
        },
        // Downgrade confirm dialog
        downgradeConfirm: {
            title: 'Schedule downgrade',
            titleWithTier: 'Schedule downgrade to {tier}',
            subtitle: 'Your {tier} tier stays active until {date}.',
            currentPlan: 'Current plan',
            scheduledPlan: 'Current scheduled plan',
            newDowngradePlan: 'New scheduled plan',
            effectiveDate: 'Effective date',
            currentCredits: 'Current credits',
            creditsKept: 'Kept until their original expiration dates',
            creditsExpire: 'Will expire at period end',
            creditsNextCycle: 'Credits next cycle',
            nextRenewal: 'Next renewal',
            renewalAmount: 'US$ {amount} on {date}',
            cancelNotice: 'You can cancel this scheduled downgrade before {date}.',
            loadFailed: 'Failed to load downgrade details.',
            retry: 'Retry',
            keepCurrentPlan: 'Keep current plan',
            keepTier: 'Keep {tier}',
            processing: 'Processing...',
            scheduleDowngrade: 'Schedule downgrade',
            credits: '{amount} credits',
            successMessage: 'Downgrade scheduled successfully! Your {tier} plan will remain active until {date}.',
        },
        oldProTip: {
            title: 'Subscription update unavailable',
            description: 'You’re currently on an active legacy Pro subscription. Legacy count-based plans and Credits plans can’t be active at the same time. To switch to a Credits plan, please cancel renewal first. After your current subscription ends, you can subscribe to a new plan.',
            confirm: 'View subscription',
            cancel: 'Got it',
        },
        coreAgents: {
            note: 'Selected core agents includes:',
            line1: 'For IP Searching: Novelty Search / FTO Search / Design FTO Search',
            line2: 'For IP Drafting: Patent Drafting / Invention Disclosure / Office Action Response',
            line3: 'For SEP: Essentiality Claim Chart',
            line4: 'For Engineering: Find Solutions with TRIZ / Quick Research',
            line5: 'For Life Sciences: Lead Compound / SAR Data Extraction / Document Analyzer',
            line6: 'For Materials: Find Solution (Materials) / Formulation',
        },
    },
};

export const jp = {
    creditsPricing: {
        title: 'あなたに合ったプランを選択しましょう',
        subtitle: 'プロフェッショナル機能を解放し、生産性を向上させましょう',
        headerTexts: {
            pricing_proactive_view: { title: '自分に合ったプランを選択', subtitle: 'アップグレードまたは Credits の追加で、より多くの機能を利用できます。' },
            feature_upgrade_required: { title: 'アップグレード後に利用できます', subtitle: 'この機能は現在のプランには含まれていません。' },
            credits_limit_upgrade: { title: 'クレジットが不足しています', subtitle: 'クレジットを追加するか、プランをアップグレードすると引き続き利用できます。' },
        },
        free: '無料',
        currentPlan: '現在のプラン',
        recommend: 'おすすめ',
        monthly: '月払い',
        yearly: '年払い',
        month: '月',
        perMonth: '/月',
        save: '$ お得',
        upgrade: 'アップグレード',
        downgrade: 'ダウングレード',
        contactSales: '営業に問い合わせ',
        bookDemo: 'デモを予約',
        custom: 'カスタム',
        learnMore: '詳しく見る',
        creditsPerMonth: '{credits} クレジット/月',
        creditsPerMonthSuffix: 'クレジット/月',
        scheduledDowngrade: '予約降級',
        scheduledDowngradeNotice: '{date} に {tier} への降級を予約済み',
        fiveXCreditsNotice: {
            title: '早期アクセス価格が適用されています。',
            description: 'すべてのプランに標準クレジットの {multiplier} 倍が含まれ、更新時も同じ料金が適用されます。変更がある場合は、次の請求サイクルの 7 日前にお知らせします。',
        },
        freeCreditsRefresh: '無料クレジットは毎月リフレッシュ',
        creditsIncluded: 'プロプランに含まれるクレジット',
        everythingInBasic: 'ベーシック版のすべてに加えて：',
        everythingInPro: '個人プロフェッショナル版のすべてに加えて：',
        everythingInProPlus: '個人プロフェッショナル版のすべてに加えて：',
        securityControl: 'セキュリティと管理',
        audienceTabs: {
            individual: '個人',
            teams: 'チーム・企業',
        },
        enterpriseCategories: {
            teamUsage: 'チーム利用と管理',
            collaboration: 'コラボレーション',
            governanceSecurity: 'ガバナンスとセキュリティ',
            serviceSuccess: 'サービスとサクセス',
        },
        apiCategories: {
            customWorkflowApi: 'カスタムワークフロー向け API',
            plugAndPlayUiComponents: '組み込み型 UI ウィジェット',
            enterpriseAiMcpServer: '企業 AI 向け MCP サーバー',
            agentSkillsSdk: 'エージェントスキルと SDK',
            interactiveDeveloperPlayground: 'インタラクティブな開発者プレイグラウンド',
        },
        basic: 'ベーシック版',
        pro: '個人プロフェッショナル版',
        enterprise: 'エンタープライズ版',
        api: 'オープンプラットフォーム',
        basicDesc: 'コア AI ワークフローをすぐに開始',
        proDesc: '実務ワークフローを運用するプロフェッショナル向け',
        enterpriseDesc: 'チームで全サイクルのイノベーション力を安全に拡張',
        apiDesc: 'R&D インテリジェンスを自社スタックに組み込む',
        features: {
            basic1: '一部のコアエージェントを利用可能',
            basic2: 'すぐに使える R&D ワークフロー、厳選データツールを備えた内蔵スキルとコネクター',
            basic3: '競合インテリジェンスを追跡する AI 対応の動向モニター',
            pro1: '調査、ドラフト作成、検証、モニタリングに対応する、より深いエージェントワークフロー',
            pro2: '裏付け証拠（特許・文献）付きのプロフェッショナルなエクスポート',
            pro3: 'より多くの技術トピックと競合シグナルの追跡',
            // Enterprise - Team usage & administration
            enterpriseTeam1: 'チームのニーズに合わせたアクセス設定',
            enterpriseTeam2: 'カスタム配分に対応したチーム共有クレジット',
            enterpriseTeam3: '請求、利用状況、ユーザー管理のための管理コンソール',
            // Enterprise - Collaboration
            enterpriseCollab1: '共有ワークスペースとチームプロジェクト',
            enterpriseCollab2: 'チーム全体へのインテリジェンス配信',
            // Enterprise - Governance & Security
            enterpriseSecurity1: 'SSO とエンタープライズ向けセキュリティ制御',
            enterpriseSecurity2: 'ユーザーとワークスペースのロールベース権限',
            enterpriseSecurity3: 'ファイルアップロード制御',
            enterpriseSecurity4: 'プライベート・インコグニートモード',
            // Enterprise - Service & Success
            enterpriseService1: '専任カスタマーサポート',
            enterpriseService2: '99.9% SLA とプロアクティブ監視',
            enterprise1: '個人メンバーのクォータ管理',
            enterprise2: 'チーム向け無制限共有Vault',
            security1: '内部インテリジェンス共有',
            security2: 'プライベートシークレットモード',
            security3: '統合チーム権限管理',
            security4: '専任カスタマーサポート',
            api1: '特許、ライフサイエンス、R&D、マーケットインテリジェンスを横断する 300+ データ API と 60+ AI エージェント API',
            api2: 'チャート、インサイト、AI ワークフローを自社プロダクトに組み込み。再構築は不要',
            api3: 'Claude Desktop や Cursor を含む任意の MCP 対応クライアントから、信頼できる PatSnap ツールに接続',
            api4: 'LangChain、OpenClaw、CrewAI などのフレームワークでワークフローを構築・オーケストレーション',
            api5: 'シナリオデモの確認、API テスト、ウィジェット構築、コード生成を一か所で実行',
        },
        // アップグレード確認ダイアログ
        upgradeConfirm: {
            title: 'アップグレード',
            titleWithTier: '{tier} にアップグレード',
            subtitle: 'アップグレードは即座に有効になります。',
            currentPlan: '現在のプラン',
            targetPlan: '対象プラン',
            dueToday: '本日のお支払い',
            creditsGrantedToday: '本日付与されるクレジット',
            creditsValidUntil: 'クレジット有効期限',
            nextRenewal: '次回更新',
            creditsRetainedNotice: '既存のクレジットは保持され、新しいクレジットと併用できます。',
            loadFailed: 'アップグレード詳細の読み込みに失敗しました。',
            retry: '再試行',
            cancel: 'キャンセル',
            processing: '処理中...',
            upgradeNow: '今すぐアップグレード',
            credits: '+{amount} クレジット',
            upgradeSuccess: 'ご登録ありがとうございます！ 早期利用特典として、5倍クレジットがアカウントに付与されました。ぜひご確認ください。',
        },
        // ダウングレード確認ダイアログ
        downgradeConfirm: {
            title: 'ダウングレードを予約',
            titleWithTier: '{tier} へのダウングレードを予約',
            subtitle: '{tier} プランは {date} まで有効です。',
            currentPlan: '現在のプラン',
            scheduledPlan: '現在の降级方案',
            newDowngradePlan: '新降级方案',
            effectiveDate: '有効日',
            currentCredits: '現在のクレジット',
            creditsKept: '元の有効期限まで保持',
            creditsExpire: '期間終了時に失効',
            creditsNextCycle: '次サイクルのクレジット',
            nextRenewal: '次回更新',
            renewalAmount: '{date} に US$ {amount}',
            cancelNotice: '{date} までにこの予約ダウングレードをキャンセルできます。',
            loadFailed: 'ダウングレード詳細の読み込みに失敗しました。',
            retry: '再試行',
            keepCurrentPlan: '現在のプランを維持',
            keepTier: '{tier} を維持',
            processing: '処理中...',
            scheduleDowngrade: 'ダウングレードを予約',
            credits: '{amount} クレジット',
            successMessage: 'ダウングレード予約成功！{tier} プランは {date} まで有効です。',
        },
        oldProTip: {
            title: 'サブスクリプションを更新できません',
            description: '現在、有効な旧 Pro サブスクリプションをご利用中です。旧カウント制プランと Credits プランを同時に有効にすることはできません。Credits プランに切り替えるには、先に自動更新をキャンセルしてください。現在のサブスクリプション終了後、新しいプランを購読できます。',
            confirm: 'サブスクリプションを確認',
            cancel: '了解しました',
        },
        coreAgents: {
            note: '主要なコアAIエージェント：',
            line1: 'IP検索：AI新規性検索 / FTO調査 / 意匠FTO調査',
            line2: 'IP出願：特許出願 / 発明開示書 / 拒絶理由対応',
            line3: 'SEP：SEPクレームチャート',
            line4: 'エンジニアリング：ソリューション探索(TRIZ) / クイックリサーチ',
            line5: 'ライフサイエンス：Lead 化合物解析 / SARデータ抽出 / Document Analyzer',
            line6: '材料開発：材料技術ソリューション探索 / 配合ラボ',
        },
    },
};

export const tw = {
    creditsPricing: {
        title: '選擇最適合您的方案',
        subtitle: '解鎖專業功能，提升您的工作效率',
        headerTexts: {
            pricing_proactive_view: { title: '選擇適合你的方案', subtitle: '升級方案或增加 Credits，解鎖更多能力。' },
            feature_upgrade_required: { title: '升級後即可使用此功能', subtitle: '此功能不包含在目前方案中，請升級後繼續。' },
            credits_limit_upgrade: { title: 'Credits 不足', subtitle: '增加 Credits 或升級方案後，即可繼續使用。' },
        },
        free: '免費',
        currentPlan: '目前方案',
        recommend: '推薦',
        monthly: '月付',
        yearly: '年付',
        month: '月',
        perMonth: '/月',
        save: '省 $',
        upgrade: '升級',
        downgrade: '降級',
        contactSales: '聯繫銷售',
        bookDemo: '預約演示',
        custom: '客製化',
        learnMore: '瞭解更多',
        creditsPerMonth: '{credits} 積分/月',
        creditsPerMonthSuffix: '積分/月',
        scheduledDowngrade: '預約降級',
        scheduledDowngradeNotice: '預約 {date} 降級到 {tier}',
        fiveXCreditsNotice: {
            title: '早鳥優惠已為您啟用。',
            description: '每個套餐包含標準積分的 {multiplier} 倍，續費時將維持相同費率。如有變更，我們將在下一個計費週期前 7 天通知您。',
        },
        freeCreditsRefresh: '免費積分每月刷新',
        creditsIncluded: '專業版方案包含的積分',
        everythingInBasic: '包含基礎版全部能力，並增加：',
        everythingInPro: '包含個人專業版全部能力，並增加：',
        everythingInProPlus: '包含個人專業版全部能力，並增加：',
        securityControl: '安全與管理',
        audienceTabs: {
            individual: '個人',
            teams: '團隊與企業',
        },
        enterpriseCategories: {
            teamUsage: '團隊使用與管理',
            collaboration: '協作',
            governanceSecurity: '治理與安全',
            serviceSuccess: '服務與成功',
        },
        apiCategories: {
            customWorkflowApi: '自訂工作流 API',
            plugAndPlayUiComponents: '即插即用 UI 元件',
            enterpriseAiMcpServer: '面向企業 AI 的 MCP 伺服器',
            agentSkillsSdk: '智能體技能與 SDK',
            interactiveDeveloperPlayground: '互動式開發者體驗場',
        },
        basic: '基礎版',
        pro: '個人專業版',
        enterprise: '企業版',
        api: '開放平台',
        basicDesc: '從核心 AI 工作流快速開始',
        proDesc: '適合執行真實工作流的專業使用者',
        enterpriseDesc: '適合團隊安全擴展全流程創新能力',
        apiDesc: '把研發智慧嵌入你自己的系統',
        features: {
            basic1: '可使用部分核心智能體',
            basic2: '內建技能和連接器，提供開箱即用的研發工作流與精選資料工具',
            basic3: 'AI 驅動的情報簡報，持續追蹤競爭情報',
            pro1: '更深入的智能體工作流，涵蓋研究、撰寫、驗證與監控',
            pro2: '可匯出帶有佐證資料的專業成果（專利與文獻）',
            pro3: '追蹤更多技術主題和競爭訊號',
            // Enterprise - Team usage & administration
            enterpriseTeam1: '依團隊需求客製化存取權限',
            enterpriseTeam2: '團隊共用點數池，支援自訂分配',
            enterpriseTeam3: '管理員控制台，統一管理帳單、用量和使用者',
            // Enterprise - Collaboration
            enterpriseCollab1: '共享工作區和團隊專案',
            enterpriseCollab2: '團隊級情報分發',
            // Enterprise - Governance & Security
            enterpriseSecurity1: 'SSO 與企業級安全控制',
            enterpriseSecurity2: '基於角色的使用者和工作區權限',
            enterpriseSecurity3: '檔案上傳控制',
            enterpriseSecurity4: '私密無痕模式',
            // Enterprise - Service & Success
            enterpriseService1: '專屬客戶支援',
            enterpriseService2: '99.9% SLA 與主動監控',
            enterprise1: '個人成員配額管理',
            enterprise2: '無限團隊共享知識庫',
            security1: '內部情報共享',
            security2: '隱私無痕模式',
            security3: '統一團隊權限管理',
            security4: '專屬客戶支持',
            api1: '橫跨專利、生命科學、研發和市場情報的 300+ 資料 API 與 60+ AI 智能體 API',
            api2: '將圖表、洞察和 AI 工作流嵌入你的產品，無需重建',
            api3: '透過任何相容 MCP 的客戶端連接可信任的 PatSnap 工具，包括 Claude Desktop 和 Cursor',
            api4: '使用 LangChain、OpenClaw、CrewAI 等框架建構並編排工作流',
            api5: '在一個平台內探索場景示範、測試 API、建構元件並生成程式碼',
        },
        // 升級確認彈窗
        upgradeConfirm: {
            title: '升級',
            titleWithTier: '升級到 {tier}',
            subtitle: '升級立即生效。',
            currentPlan: '目前方案',
            targetPlan: '目標方案',
            dueToday: '今日應付',
            creditsGrantedToday: '今日獲得積分',
            creditsValidUntil: '積分有效期至',
            nextRenewal: '下次續費',
            creditsRetainedNotice: '您現有的積分將被保留，可與新積分一起使用。',
            loadFailed: '載入升級詳情失敗。',
            retry: '重試',
            cancel: '取消',
            processing: '處理中...',
            upgradeNow: '立即升級',
            credits: '+{amount} 積分',
            upgradeSuccess: '感謝訂閱！ 你的早鳥獎勵已到帳：5 倍積分已發放至你的帳戶，快去查看吧。',
        },
        // 降級確認彈窗
        downgradeConfirm: {
            title: '預約降級',
            titleWithTier: '預約降級到 {tier}',
            subtitle: '您的 {tier} 套餐將保持有效至 {date}。',
            currentPlan: '目前方案',
            scheduledPlan: '現在的降级方案',
            newDowngradePlan: '新的降级方案',
            effectiveDate: '生效日期',
            currentCredits: '目前積分',
            creditsKept: '保留至原到期日',
            creditsExpire: '將在週期結束時過期',
            creditsNextCycle: '下週期積分',
            nextRenewal: '下次續費',
            renewalAmount: '{date} 續費 US$ {amount}',
            cancelNotice: '您可以在 {date} 之前取消此預約降級。',
            loadFailed: '載入降級詳情失敗。',
            retry: '重試',
            keepCurrentPlan: '保持目前方案',
            keepTier: '保持 {tier}',
            processing: '處理中...',
            scheduleDowngrade: '預約降級',
            credits: '{amount} 積分',
            successMessage: '降级预约成功！您的 {tier} 套餐将保持有效至 {date}。',
        },
        oldProTip: {
            title: '暫時無法更新訂閱',
            description: '你目前仍在舊版 Pro 訂閱週期內。舊版計次套餐與 Credits 積分套餐無法同時生效。如需切換至 Credits 積分套餐，請先取消續訂；目前訂閱結束後，你可以重新訂閱新套餐。',
            confirm: '查看訂閱',
            cancel: '我知道了',
        },
        coreAgents: {
            note: '精選智能體包括：',
            line1: 'IP 檢索：查新檢索 / 防侵權檢索 / 外觀防侵權檢索',
            line2: 'IP 撰寫：專利申請 / 交底書 / 審查意見答覆',
            line3: 'SEP：標準比對',
            line4: '工程研發：TRIZ 尋找創新方案 / 技術預研報告',
            line5: '生命科學：Lead 化合物分析 / SAR數據提取 / 文檔精讀',
            line6: '材料研發：材料技術方案探索 / 配方助手',
        },
    },
};
